"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var awsui_table_pagination_1 = require("./awsui-table-pagination");
var CardsPaginationWrapper = /** @class */ (function (_super) {
    __extends(CardsPaginationWrapper, _super);
    function CardsPaginationWrapper(element) {
        var _this = _super.call(this, element) || this;
        _this.name = 'cards';
        return _this;
    }
    return CardsPaginationWrapper;
}(awsui_table_pagination_1.BaseCollectionPaginationWrapper));
exports.default = CardsPaginationWrapper;
//# sourceMappingURL=awsui-cards-pagination.js.map